import { useEffect } from 'react'
import type { ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { acquireWakeLock, attachWakeLockListeners, releaseWakeLock } from '@/lib/wakeLock'

export function DashboardShell({ children }: { children: ReactNode }) {
  useEffect(() => {
    void acquireWakeLock()
    const detach = attachWakeLockListeners()
    return () => {
      detach()
      releaseWakeLock()
    }
  }, [])

  return (
    <div className="relative flex size-full flex-col bg-surface-0 text-ink">
      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-40 top-1/3 size-[36rem] rounded-full bg-[radial-gradient(closest-side,var(--brand-primary)_0%,transparent_70%)] opacity-[0.06]" />
        <div className="absolute -right-40 top-2/3 size-[36rem] rounded-full bg-[radial-gradient(closest-side,var(--brand-accent)_0%,transparent_70%)] opacity-[0.05]" />
      </div>

      <Header />
      <main className="relative flex flex-1 min-h-0 px-8">{children}</main>
      <Footer />
    </div>
  )
}
